import { Placeholder } from 'react-bootstrap'
import React from 'react'

export const MediumLoadingPlaceholder = () => {
  return (
    <div>
      <Placeholder animation="glow">
        <Placeholder md={7} />
        <Placeholder md={12} size="xs" bg="primary" />
      </Placeholder>
    </div>
  )
}
